import { Text } from '@modusign/design-system';
import moment from 'moment';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import InPersonHostInfoBadge from '@app/components/InPersonHostInfoBadge';
import { getBizNumberFormat, getFormattedSouthKoreaPhoneNumber } from '@app/libs/inputFormat';
import {
  getHostsByDataLabel,
  getParticipants,
} from '@app/store/signingProgressInformation/selectors';

function ParticipantsInfo() {
  const participants = useSelector(getParticipants);
  const hostsByDataLabel = useSelector(getHostsByDataLabel);

  const isSigningInOrder = useMemo(() => {
    return !participants.every((participant) => participant.signingOrder === 1);
  }, [participants]);

  return (
    <div className="box-5x">
      <h5 className="space-3x">서명자 정보</h5>
      {participants.map((participant) => {
        let mobileAuthText: string | null = null;
        if (participant.mobileAuth) {
          const { phoneNumber, realName } = participant.mobileAuth;
          mobileAuthText = `휴대폰 본인 인증 (${realName} ${getFormattedSouthKoreaPhoneNumber(
            phoneNumber
          )})`;
        }

        let digitalCertificateAuthText: string | null = null;
        if (participant.digitalCertificateAuth) {
          const { bizNumber, companyName } = participant.digitalCertificateAuth;
          digitalCertificateAuthText = `법인 공동인증서 인증 (${companyName} ${getBizNumberFormat(
            bizNumber
          )})`;
        }

        const host = participant.host ? hostsByDataLabel[participant.host.dataLabel] : null;

        return (
          <div key={participant.participantId}>
            <div className="space-1x">
              <b>
                {isSigningInOrder && `${participant.signingOrder}.`}
                {participant.name} ({participant.signingMethod.contactInfo})
                {host && (
                  <Text ml={2}>
                    <InPersonHostInfoBadge {...host} />
                  </Text>
                )}
              </b>
            </div>
            <table className="InfoTable">
              <tbody>
                {host && (
                  <tr>
                    <th className="InfoTable__label-cell">진행자</th>
                    <td className="InfoTable__value-cell">{`${host?.name} (${host.contactInfo})`}</td>
                  </tr>
                )}
                <tr>
                  <th className="InfoTable__label-cell">진행 상태</th>
                  <td className="InfoTable__value-cell">{participant.progressStatus}</td>
                </tr>
                {participant.progressStatus === '서명 필요' && (
                  <tr>
                    <th className="InfoTable__label-cell">서명 유효기간</th>
                    <td className="InfoTable__value-cell">
                      {moment(participant.signingExpiryDate).format(
                        'YYYY년 MM월 DD일 a hh시 mm분 까지'
                      )}
                    </td>
                  </tr>
                )}
                {(participant.digitalCertificateAuth ||
                  participant.mobileAuth ||
                  participant.isPasswordAuth) && (
                  <tr>
                    <th className="InfoTable__label-cell">추가 인증 정보</th>
                    <td className="InfoTable__value-cell">
                      {participant.isPasswordAuth && <Text as="p">접근암호 인증</Text>}
                      {mobileAuthText && <Text as="p">{mobileAuthText}</Text>}
                      {digitalCertificateAuthText && (
                        <Text as="p">{digitalCertificateAuthText}</Text>
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
}

export default ParticipantsInfo;
